import { memo } from 'react';
import { FormattedDate } from 'react-intl';

import { useIntl } from '../../../hooks';
import { hzToMhz } from '../../../lib/frequency';
import { formatOptionalNumber, parseKvNumber } from '../../../lib/number-format';
import type { Detection } from '../../../types/detection';
import { renderSignalDirectionIcon } from '../../SignalDirectionIcon';
import { TableCell, TableRow } from '../../ui';

type DetectionEventRowProps = {
  detection: Detection;
};

export const DetectionEventRow = memo(function DetectionEventRow({
  detection,
}: DetectionEventRowProps) {
  const intl = useIntl();
  const bandwidthHz = parseKvNumber(detection.bandwidth);
  const offsetHz = parseKvNumber(detection.offset);
  const signalLevelValue = parseKvNumber(detection.signalLevel);
  const snrValue = parseKvNumber(detection.snr);
  const pattern = detection.patternType ?? '-';
  const bandwidthMhz = bandwidthHz === null ? null : hzToMhz(bandwidthHz);
  const offsetMhz = offsetHz === null ? null : hzToMhz(offsetHz);
  const ts = detection.ts ? new Date(detection.ts) : null;

  return (
    <TableRow>
      <TableCell>
        {renderSignalDirectionIcon(
          detection.direction,
          intl.formatMessage({
            id: `detections.table.directions.${detection.direction}`,
          }),
        )}
      </TableCell>
      <TableCell>{formatOptionalNumber(bandwidthMhz)}</TableCell>
      <TableCell>{formatOptionalNumber(offsetMhz)}</TableCell>
      <TableCell>{formatOptionalNumber(signalLevelValue)}</TableCell>
      <TableCell>{formatOptionalNumber(snrValue)}</TableCell>
      <TableCell>{pattern}</TableCell>
      <TableCell className="text-xs text-foreground">
        {ts ? (
          <FormattedDate
            value={ts}
            hour="2-digit"
            minute="2-digit"
            second="2-digit"
            hour12={false}
          />
        ) : (
          '-'
        )}
      </TableCell>
    </TableRow>
  );
});
